import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteMachineGroup } from "@/api/machine-group-api";

import { MACHINE_GROUPS_QUERY_KEY } from "./use-machine-groups";

export const useDeleteMachineGroup = () => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (id: string) => deleteMachineGroup(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: MACHINE_GROUPS_QUERY_KEY });
		},
	});

	return {
		mutate: mutation.mutateAsync,
		isPending: mutation.isPending,
		isSuccess: mutation.isSuccess,
		isError: mutation.isError,
		error: mutation.error,
	};
};
